import { defineMessages, useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework/index.ts";
import { LogoV2 as Logo } from "@/libraries/wpl/foundations/src";
import { LogoBrandV2 } from "@/libraries/wpl/foundations/src";

type LogoLinkContainerProps = {
    logoType?: LogoBrandV2;
};

// ==================================================================
// Rendering Functions
// ==================================================================
export const LogoLinkContainer = ({ logoType }: LogoLinkContainerProps) => {
    const intl = useIntl();
    const messages = defineMessages({
        ariaLabelLogo: {
            id: "globalfooterv2.top.logo-label",
            defaultMessage: "Atlassian logo"
        }
    });

    const localizedHref = useLocalizedHref("/");

    const dataEvent = "clicked";
    const dataEventComponent = "linkButton";
    const dataEventContainer = "globalFooterV2";
    // const dataProductKey = "TO DO: depends on page"

    return (
        <a
            aria-label={intl.formatMessage(messages.ariaLabelLogo)}
            href={localizedHref}
            data-event={dataEvent}
            data-event-component={dataEventComponent}
            data-event-container={dataEventContainer}
        >
            <Logo
                brand={logoType || "atlassian"}
                type="mark"
                appearance="brand"
                width={32}
                height={32}
            />
        </a>
    );
};
